export default "__VITE_ASSET__a343e57d__"